// Copyright (c) 2023 Siemens

export function isNullOrEmpty(stringVal) {
    let isEmpty = false;
    if (stringVal === '' || stringVal === null) {
        isEmpty = true;
    }
    return isEmpty;
}
